module.exports = __webpack_public_path__ + "static/media/yoni_cohen.f85f0a19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/yoni_cohen.jpg
// module id = 211
// module chunks = 0